/**
 * Typed wafer imaging templates API facade over the generated contract client.
 */

import { waferImagingTemplatesApi } from '../api/generated/waferImagingTemplates.api.js';
import type {
  CreateWaferImagingTemplateRequest,
  UpdateWaferImagingTemplateRequest,
  WaferImagingTemplateListItem,
} from '@cnapse/shared/schemas.js';

export type { WaferImagingTemplateListItem };

class WaferImagingTemplatesService {
  async listWaferImagingTemplates(): Promise<WaferImagingTemplateListItem[]> {
    return waferImagingTemplatesApi.list() as Promise<WaferImagingTemplateListItem[]>;
  }

  async getWaferImagingTemplate(id: number): Promise<WaferImagingTemplateListItem> {
    return waferImagingTemplatesApi.getById(id) as Promise<WaferImagingTemplateListItem>;
  }

  async createWaferImagingTemplate(
    body: CreateWaferImagingTemplateRequest,
  ): Promise<WaferImagingTemplateListItem> {
    return waferImagingTemplatesApi.create(body) as Promise<WaferImagingTemplateListItem>;
  }

  async updateWaferImagingTemplate(
    id: number,
    body: UpdateWaferImagingTemplateRequest,
  ): Promise<WaferImagingTemplateListItem> {
    return waferImagingTemplatesApi.update(id, body) as Promise<WaferImagingTemplateListItem>;
  }

  async deleteWaferImagingTemplate(id: number): Promise<void> {
    await waferImagingTemplatesApi.delete(id);
  }
}

export const waferImagingTemplatesService = new WaferImagingTemplatesService();
